"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var storybook_1 = require("@eyecons/storybook");
var ra_fetch_1 = require("ra-fetch");
function FormTag(_a) {
    var video = _a.video, tags = _a.tags, setTags = _a.setTags;
    var initTag = {
        video_id: video.id,
        channel_id: '',
        hidden: 0,
        owner: 0,
        starred: 0,
    };
    var channels = ra_fetch_1.useApi('backend').index('channels', {
        type: 'player',
        club_id: video.channel_id
    })[0];
    var _b = ra_fetch_1.useApi('backend')
        .records(setTags, tags)
        .store('tags', initTag), tag = _b[0], setTag = _b[1], submitTag = _b[2];
    function submit() {
        submitTag().then(function (response) {
            if (!response.errors.length) {
                setTag(initTag);
            }
        });
    }
    if (!channels.data.length) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    return react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(storybook_1.Texts.Small, { className: 'mt-4 mb-6' }, "Maak een nieuwe tag voor de video"),
        react_1.default.createElement(storybook_1.Forms.Select, { className: 'mb-6', value: tag.data.channel_id, onChange: function (channel_id) { return setTag({ channel_id: channel_id }); } },
            react_1.default.createElement("option", null, "Kies een kanaal"),
            channels.data.map(function (channel, index) {
                return react_1.default.createElement("option", { value: channel.id, key: index }, channel.label);
            })),
        react_1.default.createElement("div", { className: 'flex' },
            react_1.default.createElement(storybook_1.Buttons.Button, { className: 'ml-auto', onClick: submit, type: 'primary' }, "Voeg tag toe")));
}
exports.default = FormTag;
